import React from "react";
import "./NotFound.css";
import Image1 from "../../assets/images/client-dashboard/404.png";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import Topbar from "../Components/Topbar/Topbar";
const NotFound = () => {
  return (
    <div className="clientdashboard__not_found">
      <div className="clientdashboard__not_foundtbwrap">
        <div className="clientdashboard__not_foundtbwraplft"></div>
        <Topbar />
      </div>
      <div className="clientdashboard__not_foundcontent">
        <div className="clientdashboard__not_foundimg">
          <img src={Image1} alt="" />
        </div>
        <div className="clientdashboard__not_foundtxt">
          The page you are looking for was not found.
        </div>
        <Link
          className="clientdashboard__not_foundbtn"
          to="/client-dashboard/home"
        >
          Back to Home
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
